var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.pilot.State.IsMounted ? _c("pilot-block") : _c("mech-block"),
      _vm._v(" "),
      _c("deployed-block")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }